import { useEffect, useState } from 'react';

export const useBanner = () => {
  const [isPromo, setIsPromo] = useState(false);

  // This is for Mother's Month in May, 2026 (Apr, 30 2026 7:00 PM EST  - Jun, 1 2026 11:00 AM EST)
  const firstDay = 1777593600;
  const lastDay = 1780329600;

  useEffect(() => {
    const currentTime = Math.floor(new Date().getTime() / 1000);

    if (firstDay <= currentTime && currentTime < lastDay) {
      setIsPromo(true);
    } else {
      setIsPromo(false);
    }
  }, []);

  return {
    isPromo,
  };
};
